"use client";

import { c as _c } from "react/compiler-runtime";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { isMemesQuickVoteMissingDropError } from "@/hooks/memesQuickVote.errors";
import { isMemesQuickVoteDiscoverableDrop } from "@/hooks/memesQuickVote.helpers";
import { fetchMemesQuickVoteDrop, getMemesQuickVoteDropQueryKey } from "@/hooks/memesQuickVote.query";
import { useMemesQuickVoteContext } from "@/hooks/useMemesQuickVoteContext";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export const useMemesQuickVoteHiddenSummaryCleanup = t0 => {
  const $ = _c(13);
  const {
    activeCandidateId,
    enabled,
    isFetchingPage,
    isSummarySuccess,
    memesWaveId,
    onClearHiddenSummaryDrop,
    skippedDropIds,
    summaryFirstDrop
  } = t0;
  const {
    contextProfile,
    proxyId
  } = useMemesQuickVoteContext();
  let t1;
  bb0: {
    if (!enabled || !isSummarySuccess || !summaryFirstDrop || !skippedDropIds.includes(summaryFirstDrop.id) || activeCandidateId !== null || isFetchingPage) {
      t1 = null;
      break bb0;
    }
    t1 = summaryFirstDrop.id;
  }
  const hiddenSummaryDropId = t1;
  let t2;
  if ($[0] !== contextProfile || $[1] !== hiddenSummaryDropId || $[2] !== proxyId) {
    t2 = hiddenSummaryDropId ? getMemesQuickVoteDropQueryKey({
      contextProfile,
      dropId: hiddenSummaryDropId,
      proxyId
    }) : ["memes-quick-vote-hidden-summary-drop", null];
    $[0] = contextProfile;
    $[1] = hiddenSummaryDropId;
    $[2] = proxyId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hiddenSummaryDropId || $[5] !== memesWaveId || $[6] !== onClearHiddenSummaryDrop) {
    t3 = async () => {
      const dropId = hiddenSummaryDropId;
      if (dropId === null) {
        return null;
      }
      ;
      try {
        const drop = await fetchMemesQuickVoteDrop(dropId);
        if (!isMemesQuickVoteDiscoverableDrop({
          drop,
          waveId: memesWaveId
        })) {
          onClearHiddenSummaryDrop(dropId);
          return null;
        }
        return drop;
      } catch (t4) {
        const error = t4;
        if (isMemesQuickVoteMissingDropError(error)) {
          onClearHiddenSummaryDrop(dropId);
          return null;
        }
        throw error;
      }
    };
    $[4] = hiddenSummaryDropId;
    $[5] = memesWaveId;
    $[6] = onClearHiddenSummaryDrop;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = hiddenSummaryDropId !== null;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getDefaultQueryRetry();
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t6 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      ...t5,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 0
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useQuery(t6);
};